export enum TraceStepperState {
    NotVisited = "NotVisited",
    Active = "Active",
    Completed = "Completed",
}
